module.exports = __webpack_public_path__ + "img/about9.60b997f5.png";